module.exports = __webpack_public_path__ + "02_veryshort_gold.7abeac25.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/02_veryshort_gold.png
// module id = 3M+f
// module chunks = 0